export class File {
    _id?: string;
    filename?: string;
    path?: string;
    context?:string;
    filetype?: string;
    owner?: string;
    service?: string;
    serviceId?: string;
    company?: string;
    project?: string;
}
